import { Pipe, PipeTransform } from '@angular/core';
import { partition } from 'lodash';

@Pipe({ name: 'bisect' })
export class BisectPipe implements PipeTransform {
  transform<T extends any>(value: T[]): [T[], T[]] {
    const middle = Math.ceil(value.length / 2);

    return partition(value, item => value.indexOf(item) < middle);
  }
}
